import { getExternalAccountName } from '@/common/components/employees/external-account/ExternalAccountName';
import { EmployeeExternalAccountStatus, EmployeeExternalAccountType } from '@/common/graphql';
import { ObjectUtils } from '@/common/utils';
import type { ComboboxItemWithFormatted } from '../props';
import { SelectMultiple, type SelectMultipleProps } from '../SelectMultiple';

interface EmployeeExternalAccountStatusSelectMultipleProps
  extends Omit<SelectMultipleProps<ComboboxItemWithFormatted<EmployeeExternalAccountStatus>>, 'searchable' | 'value'> {
  type: EmployeeExternalAccountType;
  value: Array<EmployeeExternalAccountStatus> | null | undefined;
}

const EmployeeExternalAccountStatusLabels: Record<EmployeeExternalAccountStatus, string> = {
  [EmployeeExternalAccountStatus.Active]: 'Active',
  [EmployeeExternalAccountStatus.Inactive]: 'Inactive',
  [EmployeeExternalAccountStatus.Suspended]: 'Suspended',
  [EmployeeExternalAccountStatus.NotExisting]: 'Not existing',
};

const filterStatusOptions: Record<EmployeeExternalAccountType, Array<EmployeeExternalAccountStatus>> = {
  [EmployeeExternalAccountType.Google]: [
    EmployeeExternalAccountStatus.Active,
    EmployeeExternalAccountStatus.Inactive,
    EmployeeExternalAccountStatus.NotExisting,
    EmployeeExternalAccountStatus.Suspended,
  ],
  [EmployeeExternalAccountType.Slack]: [
    EmployeeExternalAccountStatus.Active,
    EmployeeExternalAccountStatus.Inactive,
    EmployeeExternalAccountStatus.NotExisting,
  ],
  [EmployeeExternalAccountType.Hubspot]: [
    EmployeeExternalAccountStatus.Active,
    EmployeeExternalAccountStatus.NotExisting,
  ],
  [EmployeeExternalAccountType.Greenhouse]: [
    EmployeeExternalAccountStatus.Active,
    EmployeeExternalAccountStatus.Inactive,
    EmployeeExternalAccountStatus.NotExisting,
  ],
  [EmployeeExternalAccountType.Eloomi]: [
    EmployeeExternalAccountStatus.Active,
    EmployeeExternalAccountStatus.Inactive,
    EmployeeExternalAccountStatus.NotExisting,
  ],
  [EmployeeExternalAccountType.Github]: [
    EmployeeExternalAccountStatus.Active,
    EmployeeExternalAccountStatus.Inactive,
    EmployeeExternalAccountStatus.NotExisting,
  ],
};

const getData = (type: EmployeeExternalAccountType) =>
  ObjectUtils.arrayFromEnumValues<EmployeeExternalAccountStatus>(EmployeeExternalAccountStatus)
    .filter(it => filterStatusOptions[type].includes(it))
    .map(value => ({ label: EmployeeExternalAccountStatusLabels[value], value }));

export const EmployeeExternalAccountStatusSelectMultiple = ({
  type,
  ...rest
}: EmployeeExternalAccountStatusSelectMultipleProps) => (
  <SelectMultiple
    {...rest}
    data={getData(type)}
    loading={false}
    multipleSelectedLabel={length => `${length} statuses`}
    placeholder={rest.placeholder ?? getExternalAccountName(type)}
    searchable={false}
  />
);
